import type { FaireProductEntity } from "../../entity_types/product";

export const p_rhr7pqr45x: FaireProductEntity = {
  token: "p_rhr7pqr45x",
  type: "product",
  name: "Children's Bath Time Counter Display v2",
  brandToken: "b_8cq2ziwn",
  brandName: "Jack N' Jill Kids & NFco",
  imageUrl:
    "https://cdn.faire.com/fastly/086490f419458f3f3ac03212e9ef9197339e6e73c4d16926cb955a9d39d17031.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/aa5f1c21900ff60007856291a8f38fee101bb36ce42afaf443e3a71c956eaeed.png",
    "https://cdn.faire.com/fastly/caabf30370eeeb04b9ab0d51edad324ff26798710d60d8f27089a30b0410ab34.png",
    "https://cdn.faire.com/fastly/07564a88e25c078288bee0594b9976c264c07308fc58d9e90ddff200e104c400.png",
    "https://cdn.faire.com/fastly/227c4c92117f518ba6a85f81927cdb4ec37a4c149d8e26849548c6ca1934be85.png",
  ],
  priceDollars: 96.36,
  description:
    "Introducing the Jack N’ Jill Natural Bathtime Bundle – a thoughtfully curated trio designed to make your child’s bath time both delightful and nourishing. Crafted with gentle, plant-based ingredients, this set includes Shampoo & Body Wash, Blissful Bubbles Bubble Bath, and a Detangler & Leave-in Conditioner to ensure every bath is safe, calming, and enjoyable. Perfect for gifting or everyday use, this bundle brings fun, relaxation, and gentle care to your child’s bath routine. Dermatologically tested, vegan, cruelty-free, and Australian made with sustainable practices, it’s ideal for parents who want natural products they can trust. \n\n\nCounter Display includes the following items:\nBlissful Bubbles 300ml (3)\nShampoo & Body Wash 300ml (3)\nDetangler & Leave-in Conditioner 200ml (6)\nSmall Counter stand-flat packed (1)",
  tags: [],
  msrpDollars: 143.88,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:53:22.120Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
